import { createElement } from "./globalFunctions";

/**
 * Creates a tab link for the SHP tabs.
 * @param {string} text - Text of the tab
 * @param {string} anchor - Anchor of the tab
 * @returns {HTMLElement} - Created tab link
 */
const createShpTabLink = (text, anchor) => {
  const shpTabLi = createElement("li", ["shp-tab"]);
  const shpTabLink = createElement("a", ["shp-tab-link"], text);
  shpTabLink.href = anchor;
  shpTabLi.appendChild(shpTabLink);
  return shpTabLi;
};

/**
 * Removes the tabs switcher from the SHP tabs.
 * Used for convert switching tabs to anchors.
 */
const removeTabsSwitcher = () => {
  const shpTabLinks = document.querySelectorAll(".shp-tab-link");
  if (shpTabLinks.length === 0) return;
  for (const tabLink of shpTabLinks) {
    tabLink.removeAttribute("role");
    tabLink.removeAttribute("data-toggle");
  }
};
const pInfoWrapper = document.querySelector(".p-info-wrapper");

const handleProductTop = () => {
  const detailInfo = document.querySelector(".p-detail-info");
  const productTitle = document.querySelector(".p-detail-inner-header h1");
  const code = document.querySelector(".p-detail-inner-header .p-code");
  // const giftsWrapper = document.querySelector('.p-gifts-wrapper')

  if (pInfoWrapper) {
    if (detailInfo) {
      pInfoWrapper.prepend(detailInfo);

      if (productTitle) detailInfo.prepend(productTitle);
      // if (giftsWrapper) detailInfo.append(giftsWrapper)
      if (code) detailInfo.append(code);
    }
  }
};

const createAddToCartWrapper = () => {
  if (document.querySelector(".add-to-cart-wrapper")) return;
  const addToCartWrapper = createElement("div", ["add-to-cart-wrapper"]);
  const addToCartParent = document.querySelector(".add-to-cart");
  const addToCartBtn = document.querySelector(".add-to-cart .btn");
  const availability = document.querySelector(".availability-value");
  const priceWrapper = document.querySelector(".p-final-price-wrapper");
  const socialButtons = document.querySelector(".social-buttons-wrapper");
  // const flagsExtra = document.querySelector('.p-image .flags-extra')

  // if (flagsExtra) addToCartWrapper.appendChild(flagsExtra)
  // if (availability) addToCartWrapper.appendChild(availability)
  if (priceWrapper) addToCartWrapper.appendChild(priceWrapper);
  if (addToCartParent) addToCartWrapper.appendChild(addToCartParent);
  if (pInfoWrapper) pInfoWrapper.appendChild(addToCartWrapper);
  const quantity = document.querySelector(".add-to-cart .quantity");
  if (quantity && addToCartParent) addToCartParent.before(quantity);
  if (socialButtons) addToCartWrapper.appendChild(socialButtons);
  // if (addToCartBtn) addToCartBtn.textContent = window.language === 'cs' ? 'Do košíku' : 'Do košíka'
};

const moveTabsOnDetail = () => {
  const relatedFiles = document.querySelector("#relatedFiles");
  const basicDescription = document.querySelector(".basic-description");
  const extendedDescription = document.querySelector(".extended-description");
  const productsRelated = document.querySelector(".products-related");
  const relatedHeader = document.querySelector(".products-related-header");
  const tabContent = document.querySelector("#tab-content");
  const description = document.querySelector("#description");
  if (description) description.classList.remove("tab-pane", "fade");
  if (productsRelated) {
    tabContent.after(productsRelated);
  }
  if (relatedHeader) tabContent.after(relatedHeader);

  if (basicDescription) {
    const heading = basicDescription.querySelector("h3");
    if (heading)
      heading.textContent =
        window.language === "cs" ? "Popis produktu" : "Popis produktu";
  }
  if (extendedDescription) {
    const heading = extendedDescription.querySelector("h3");
    const table = extendedDescription.querySelector("table.detail-parameters");
    if (heading)
      heading.textContent =
        window.language === "cs" ? "Parametry" : "Parametre";
    if (table) {
      const thead = createElement("thead");
      const tr = createElement("tr");
      const th1 = createElement(
        "th",
        [],
        window.language === "cs"
          ? "Specifikace produktu"
          : "Špecifikácia produktu"
      );
      const th2 = createElement(
        "th",
        [],
        window.language === "cs"
          ? "Specifikace produktu"
          : "Špecifikácia produktu"
      );
      tr.append(th1, th2);
      thead.appendChild(tr);
      table.prepend(thead);
      const tableRows = table.querySelectorAll("tbody tr");
      if (tableRows.length === 0) return;

      for (let row of tableRows) {
        const cell = row.querySelector("th span.row-header-label");
        if (!cell) continue;

        const text = cell.textContent.trim().toLowerCase();
        if (text.startsWith("banner produktu")) {
          row.classList.add("product-banner-src");
          row.style.display = "none";
        }
      }
      const links = table.querySelectorAll("a + a");
      if (links.length === 0) return;
      for (let link of links) {
        const parentTd = link.parentElement;
        if (!parentTd) return;
        parentTd.innerHTML = parentTd.innerHTML.replace(">,", "> ");
      }
    }
  }
  if (relatedFiles) {
    relatedFiles.classList.remove("tab-pane", "fade");
    relatedFiles.removeAttribute("role");
    const filesHeading = createElement(
      "h3",
      ["files-heading"],
      window.language === "cs" ? "Ke stažení" : "Na stiahnutie"
    );
    const filesWrapper = createElement("div", ["related-files"]);
    filesWrapper.appendChild(filesHeading);
    filesWrapper.appendChild(relatedFiles);
    // if (tabContent) tabContent.appendChild(filesWrapper)
    if (extendedDescription) {
      extendedDescription.appendChild(filesHeading);
      extendedDescription.appendChild(relatedFiles);
    }

    const relatedFilesTab = document.querySelector(
      'a.shp-tab-link[href="#relatedFiles"]'
    );
    if (relatedFilesTab) {
      // relatedFilesTab.removeAttribute('role', 'data-toggle')
      // relatedFilesTab.removeAttribute('data-toggle')
      // relatedFilesTab.textContent = window.language === 'cs' ? 'Ke stažení' : 'Na stiahnutie'
      relatedFilesTab.parentElement.remove();
    }
  }
  const productVideos = document.querySelector("#productVideos");
  if (productVideos) {
    productVideos.classList.remove("tab-pane", "fade");
    const videosTab = document.querySelector(
      'a.shp-tab-link[href="#productVideos"]'
    );
    if (videosTab) {
      videosTab.removeAttribute("role");
      videosTab.removeAttribute("data-toggle");
    }
    const videoHeading = productVideos.querySelector("h3");
    if (videoHeading)
      videoHeading.textContent = window.language === "cs" ? "Video" : "Video";
    // if (extendedDescription) extendedDescription.appendChild(productVideos)
  }
  const productsAlternative = document.querySelector("#productsAlternative");
  if (productsAlternative) {
    productsAlternative.classList.remove("tab-pane", "fade");
    productsAlternative.removeAttribute("role");
    const pDetail = document.querySelector(".p-detail");
    productsAlternative
      .querySelectorAll(".alternative-heading")
      .forEach((title) => title.remove());
    const alternativeHeading = document.createElement("h2");
    alternativeHeading.classList.add("alternative-heading");
    alternativeHeading.textContent =
      window.language === "cs"
        ? "Alternativní produkty"
        : "Alternatívne produkty";
    productsAlternative.prepend(alternativeHeading);
    const products = productsAlternative.querySelector(".products");

    if (pDetail) pDetail.appendChild(productsAlternative);
  }
  /* const productParametersElm = document.querySelector(".extended-description");
if (productParametersElm) {
  const descTab = document.querySelector(
    '.shp-tab[data-testid="tabDescription"]'
  );
  productParametersElm.setAttribute("id", "productParameters");
  // Odstraň případný duplicitní tab Parametre
  document.querySelectorAll(".shp-tab>a[href='#productParameters']").forEach(tab => tab.parentElement.remove());
  let parameterTab = createShpTabLink("Parametre", "#productParameters");
  if (descTab) {
    descTab.parentElement.appendChild(parameterTab);
  }
} */

  const productTabs = document.querySelector("#p-detail-tabs");

  // Složení
  const slozeni = document.querySelector(".slozeni");
  if (slozeni) {
    document
      .querySelectorAll(".shp-tab>a[href='#slozeni']")
      .forEach((tab) => tab.parentElement.remove());
    let slozeniTab = createShpTabLink(
      window.language === "cs" ? "Složení" : "Zloženie",
      "#slozeni"
    );

    if (productTabs) {
      productTabs.appendChild(slozeniTab);
    }

    //Slozeni toggle
    const slozeniHeader = slozeni.querySelector("h3");
    if (slozeniHeader) {
      slozeniHeader.addEventListener("click", () => {
        slozeni.classList.toggle("active");
      });
    }
  }
  // Specifikace toggle
  const specifikace = document.querySelector(".specifikace");
  if (specifikace) {
    const spefifikaceHeader = specifikace.querySelector("h3");
    if (spefifikaceHeader) {
      spefifikaceHeader.addEventListener("click", () => {
        specifikace.classList.toggle("active");
      });
    }
  }
};

/* const turnProductImgToCarousel = () => {
  const thumbnails = document.querySelectorAll(".p-thumbnail");

  if (thumbnails.length) {
    let mainImage = document.querySelector(".p-image > .p-main-image"),
      productImage = document.querySelector(".product-top .p-image-wrapper"),
      sliderWrapper = document.createElement("div");

    sliderWrapper.classList.add("custom-slider-wrapper");
    sliderWrapper.appendChild(mainImage);

    thumbnails.forEach((thumb, index) => {
      if (index > 0) {
        let imgUrl = thumb.getAttribute("href"),
          aEl = document.createElement("a"),
          imgEl = document.createElement("img");
        aEl.classList.add("p-main-image");
        aEl.href = imgUrl;
        aEl.appendChild(imgEl);
        imgEl.src = imgUrl;
        sliderWrapper.appendChild(aEl);
      }
    });

    productImage.querySelector(".p-image").appendChild(sliderWrapper);
    $(sliderWrapper).slick({
      infinite: false,
      arrows: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      dots: true,
    });
  }
}; */

// moves favorites icon to the to social buttons and changes text in the icon
const handleFavoritesIcon = () => {
  const favoritesIcon = document.querySelector("#dkLabFavouriteDiv");
  const socialIcons = document.querySelector(
    ".social-buttons-wrapper .link-icons"
  );
  if (favoritesIcon && socialIcons) socialIcons.prepend(favoritesIcon);
  const favSpan = document.querySelector("#dkLabFavDetailSpan span");
  if (favSpan)
    favSpan.textContent = window.language === "cs" ? "Oblíbené" : "Obľúbené";
};

// moves flags to the image. Merges default flags with extra flags
const handleFlagsOnDetail = () => {
  const flagsDefault = document.querySelector(".p-detail-info .flags-default");
  const flagsExtra = document.querySelector(".p-image .flags-extra");
  const productImage = document.querySelector(".p-image");
  if (flagsDefault) {
    if (flagsExtra) {
      flagsDefault.appendChild(flagsExtra);
      flagsDefault.classList.add("contains-extra");
    }
    if (window.innerWidth > 767) productImage.appendChild(flagsDefault);
    else {
      const pDetailInner = document.querySelector(".p-detail-inner");
      if (pDetailInner) pDetailInner.prepend(flagsDefault);
    }
  }
  // else if (flagsExtra) {
  // 	productImage.appendChild(flagsExtra)
  // }
};

const changeTextOfLinkToDescription = () => {
  const linkToDesc = document.querySelector(
    "p[data-testid='productCardDescr'] a"
  );
  if (linkToDesc)
    linkToDesc.textContent =
      window.language === "cs" ? "Zobrazit více" : "Zobrazit viac";
};

// if there is a brand image in the brand description, allows to set it as an image in brand link in p-detail-info
const handleBrandOnDetail = () => {
  const tabBrand = document.querySelector('.shp-tab[data-testid="tabBrand"]');
  const manufacturerDescription = document.querySelector(
    "#manufacturerDescription"
  );
  // brand link in p-detail-info
  const brandInfo = document.querySelector(
    'a[data-testid="productCardBrandName"]'
  );
  if (!tabBrand || !manufacturerDescription) return;
  const manufacturerImg = manufacturerDescription.querySelector("img");
  tabBrand.remove();
  manufacturerDescription.remove();
  if (!manufacturerImg || !brandInfo) return;
  const imgWidth = manufacturerImg.naturalWidth;
  const imgHeight = manufacturerImg.naturalHeight;
  if (imgWidth) manufacturerImg.width = imgWidth;
  if (imgHeight) manufacturerImg.height = imgHeight;
  brandInfo.parentElement.classList.add("brand-info");
  const brandInfoContent = brandInfo.textContent;
  if (brandInfoContent) brandInfo.title = brandInfoContent;
  brandInfo.innerHTML = "";
  brandInfo.appendChild(manufacturerImg);

  // adds brand link to the parameters table
  const parametersTable = document.querySelector(
    "#description .detail-parameters tbody"
  );
  if (!parametersTable) return;
  const brandRow = createElement("tr");
  const brandName = createElement(
    "th",
    [],
    window.language === "cs" || window.language === "sk"
      ? "Značka:"
      : "Manufacturer:"
  );
  const brandImg = createElement("td", ["brand-img"]);
  brandImg.appendChild(brandInfo.cloneNode(true));
  brandRow.appendChild(brandName);
  brandRow.appendChild(brandImg);
  parametersTable.appendChild(brandRow);
};

// moves table variants to p-info-wrapper, creates heading and removes the variant shp-tab and button choose-variant
const handleVariantsTable = () => {
  if (document.querySelector(".p-info-wrapper #variants")) return;
  const variantsTable = document.querySelector("#variants");
  const variantsTableShpTab = document.querySelector(
    '.shp-tab[data-testid="tabVariants"]'
  );
  const detailInfo = document.querySelector(".p-detail-info");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!variantsTable) return;
  variantsTable.classList.remove("fade");
  if (variantsTableShpTab) variantsTableShpTab.remove();
  if (detailInfo) detailInfo.after(variantsTable);
  else if (pInfoWrapper) pInfoWrapper.appendChild(variantsTable);
  const variantsTableHeading = createElement(
    "p",
    ["variants-heading"],
    window.language === "cs" ? "Varianta:" : "Varianta:"
  );
  variantsTable.prepend(variantsTableHeading);

  // removes the button choose-variant
  const chooseVariant = document.querySelector("a#choose-variant");
  if (chooseVariant) {
    const chooseVariantParent = chooseVariant.parentElement;
    if (chooseVariantParent) chooseVariantParent.remove();
  }
  // on desktop, moves variant-price-wrap before btn-cart for every variant
  const variantRows = variantsTable.querySelectorAll(
    ".variant-table .table-row"
  );
  if (!variantRows.length) return;
  variantRows.forEach((row) => {
    if (window.innerWidth > 767) {
      const variantPriceWrap = row.querySelector(".variant-price-wrap");
      const addToCartBtn = row.querySelector(".btn-cart.btn");
      if (variantPriceWrap && addToCartBtn) {
        variantPriceWrap.closest(".table-col")?.remove();
        addToCartBtn.before(variantPriceWrap);
      }
    } else {
      const tableColCart = row.querySelector(".table-col.cart");
      const infoWrapper = row.querySelector(
        ".variant-name-wrapper .variant-image + div"
      );
      if (infoWrapper) {
        const availabilitySpans = infoWrapper.querySelectorAll("span");
        if (availabilitySpans.length) {
          const availabilitySpan = createElement("div", [
            "variant-availability",
          ]);
          availabilitySpans.forEach((span) => {
            availabilitySpan.appendChild(span);
          });
          if (tableColCart) {
            tableColCart.prepend(availabilitySpan);
          } else row.appendChild(availabilitySpan);
        }
      }
    }
    // restoring the advanced order popup after adding variant to cart
    const addToCartForm = row.querySelector("form.variant-submit");
    if (addToCartForm) {
      addToCartForm.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantPriceId = row.querySelector('[name="priceId"]')?.value;
        const variantQuantity = row.querySelector(".amount")?.value;
        shoptet.cartShared.addToCart({
          priceId: variantPriceId,
          amount: variantQuantity,
        });
      });
    }
  });
};
// Turns the variants in select elements in table.detail-parameters into radio inputs, so all variants are visible at once. Requires setting of variants to "Rozdělené varianty" in Shoptet admin.
const variantsHandler = (id) => {
  $(function () {
    if ($(`.variant-list select.parameter-id-${id}`).length) {
      $(`.variant-list select.parameter-id-${id}`).each(function (
        option_index
      ) {
        let so_classes = $(this).attr("class"),
          so_value = $(this).html(),
          so_attr1 = $(this).attr("data-parameter-id"),
          so_attr2 = $(this).attr("data-parameter-name"),
          so_attr3 = $(this).attr("id"),
          so_attr4 = $(this).attr("name"),
          so_newLabel = $("<div></div>").html(so_value);
        $(so_newLabel).attr("class", so_classes);
        $(so_newLabel).attr("data-parameter-id", so_attr1);
        $(so_newLabel).attr("data-parameter-name", so_attr2);
        $(so_newLabel).attr("id", so_attr3);
        $(so_newLabel).attr("name", so_attr4);
        $(so_newLabel).attr("value", option_index);
        $(this).replaceWith(so_newLabel);
      });
      if (
        $(`.variant-list:first-of-type .parameter-id-${id} option`).length == 1
      ) {
        $(`.variant-list:first-of-type .parameter-id-${id}`).prepend(
          "<option></option>"
        );
      }
      if (
        $(`.variant-list:nth-of-type(2) .parameter-id-${id} option`).length == 1
      ) {
        $(`.variant-list:nth-of-type(2) .parameter-id-${id}`).prepend(
          "<option></option>"
        );
      }
      if (
        $(`.variant-list:nth-of-type(3) .parameter-id-${id} option`).length == 1
      ) {
        $(`.variant-list:nth-of-type(3) .parameter-id-${id}`).prepend(
          "<option></option>"
        );
      }
      $(`.variant-list .parameter-id-${id} option:first-of-type`).wrap(
        "<span></span>"
      );
      $(
        `.variant-list:first-of-type .parameter-id-${id} span option`
      ).replaceWith(
        '<input type="radio" value name class="variant-default" checked="checked">'
      );
      $(
        `.variant-list:nth-of-type(2) .parameter-id-${id} span option`
      ).replaceWith(
        '<input type="radio" value name class="variant-default" checked="checked">'
      );
      $(
        `.variant-list:nth-of-type(3) .parameter-id-${id} span option`
      ).replaceWith(
        '<input type="radio" value name class="variant-default" checked="checked">'
      );
      $(`.variant-list .parameter-id-${id} option:not(:first-child)`).wrap(
        "<label class='advanced-parameter'></label>"
      );
      $(`.variant-list .parameter-id-${id} label option`).each(function (
        data_index
      ) {
        let option_value = $(this).attr("value"),
          option_html = $(this).html(),
          option_select = $(this).attr("selected"),
          option_name = $(this).parents(`.parameter-id-${id}`).attr("name"),
          option_newLabel = $("<input>"),
          option_newInDiv = $("<span class='parameter-value'></span>").html(
            option_html
          ),
          option_newBeDiv = $(
            '<span class="advanced-parameter-inner show-tooltip" title=""></span>'
          ),
          option_newApSpan = $('<span class="pkVS"></span>').html(option_html),
          option_data_index = data_index + 1;
        $(option_newLabel).attr("value", option_value);
        $(option_newLabel).attr("name", option_name);
        $(option_newLabel).attr("selected", option_select);
        $(option_newLabel).attr("data-index", option_data_index);
        $(option_newLabel).attr("type", "radio");
        $(this)
          .parents(".hidden-split-parameter")
          .children("span")
          .children("input")
          .attr("name", option_name);
        $(this).after(option_newInDiv);
        $(this).before(option_newBeDiv);
        $(this)
          .parent("label")
          .find(".advanced-parameter-inner")
          .append(option_newApSpan);
        $(this).replaceWith(option_newLabel);
      });
      const selectedInput = document.querySelector(
        'input[selected="selected"]'
      );
      if (selectedInput) {
        selectedInput.checked = true;
        selectedInput.parentElement
          .querySelector(".advanced-parameter-inner")
          .classList.add("yes-before");
      }
    }
  });
};
const productDetailSocialsBtnMove = () => {
  const socialButtonsWrapper = document.querySelector(
    ".social-buttons-wrapper"
  );
  if (!socialButtonsWrapper) return;
  const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
  if (!addToCartWrapper) return;
  addToCartWrapper.insertAdjacentElement("beforebegin", socialButtonsWrapper);
};
const flagsInDetail = () => {
  const flags = document.querySelector(".p-image-wrapper .flags");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!flags || !pInfoWrapper) return;
  pInfoWrapper.prepend(flags);
};
const wrapPrices = () => {
  const pricesWrapper = document.querySelector(
    ".add-to-cart-wrapper .p-final-price-wrapper"
  );
  const priceFinal = document.querySelector(
    ".p-final-price-wrapper .price-final"
  );
  const priceStandard = document.querySelector(
    ".p-final-price-wrapper .price-standard"
  );
  if (!priceFinal || !priceStandard) return;
  const priceWrapper = document.createElement("div");
  priceWrapper.classList.add("p-prices-wrapper");
  priceWrapper.appendChild(priceFinal);
  priceWrapper.appendChild(priceStandard);
  pricesWrapper.appendChild(priceWrapper);
};
const includeInfoLinksToSocialsWrapper = () => {
  const socialButtonsWrapper = document.querySelector(
    ".social-buttons-wrapper"
  );
  if (!socialButtonsWrapper) return;

  socialButtonsWrapper
    .querySelectorAll(".info-links, .quick-product-info")
    .forEach((el) => el.remove());

  const infoLinks = document.createElement("div");
  infoLinks.classList.add("info-links");
  const quickProductInfo = createElement("span", ["quick-product-info"]);
  quickProductInfo.textContent = "Rýchle info o produkte";
  const infoLinksMenu = createElement("ul", ["info-links-menu"]);
  if (!infoLinksItems) return;
  for (const item of infoLinksItems) {
    const li = document.createElement("li");
    const a = document.createElement("a");
    if (item.text.length > 0) {
      a.textContent = item.text;
    }
    if (item.href.length > 0) {
      a.href = item.href;
    }
    if (item.class.length > 0) {
      li.classList.add(item.class);
    }
    li.appendChild(a);
    infoLinksMenu.appendChild(li);
  }
  infoLinks.appendChild(infoLinksMenu);
  socialButtonsWrapper.appendChild(quickProductInfo);
  socialButtonsWrapper.appendChild(infoLinks);
};

const couponInDetail = () => {
  const productPrice = getShoptetDataLayer("product").priceWithVat;
  if (!productPrice) return;

  const couponFlag = document.querySelector(".flag.flag-coupon");
  const benefitItems = document.querySelectorAll(".benefitBanner__item");

  benefitItems.forEach((item) => {
    const discountedPrice = item.querySelector(".coupon-discount");
    // Smaž pouze benefitItem, který obsahuje .coupon-discount a není kupón
    if (!couponFlag && discountedPrice) {
      item.remove();
      return;
    }
    if (!discountedPrice || !couponFlag) return;

    const couponText = couponFlag.textContent.trim();
    let cuponCode = "";
    let discountValue = "";
    const match = couponText.match(/^([^#]+)#([^#]+)#/);
    if (match) {
      cuponCode = match[1];
      discountValue = match[2];
    } else {
      return;
    }

    const calculatedPrice =
      (parseFloat(productPrice) * (100 - parseFloat(discountValue))) / 100;
    discountedPrice.innerHTML = `Vaše cena ${calculatedPrice.ShoptetFormatAsCurrency()} s kódom <span class="coupon-code">${cuponCode}</span> `;
  });
};
const manipulateProductsRelated = () => {
  //Change title
  const productsRelatedHeader = document.querySelector(
    ".products-related-header"
  );
  if (!productsRelatedHeader) return;
  productsRelatedHeader.textContent =
    window.language === "cs" ? "Doporučujeme přikoupit" : "Odporúčame prikúpiť";
  //Change position
  const productRelatedBlock = document.querySelector(".products-related");
  if (!productRelatedBlock) return;
  productRelatedBlock.classList.add("products-inline");
  productRelatedBlock.classList.remove("products-block");
  document.querySelectorAll(".need-to-buy").forEach((el) => el.remove());
  const needToBuy = document.createElement("div");
  needToBuy.classList.add("need-to-buy");
  needToBuy.appendChild(productsRelatedHeader);
  needToBuy.appendChild(productRelatedBlock);
  const pTabs = document.querySelector(".p-detail-tabs-wrapper");

  if (!pTabs) return;
  pTabs.insertAdjacentElement("beforebegin", needToBuy);
};
const changeTextDescription = () => {
  const descriptionTab = document.querySelector(
    '.shp-tab[data-testid="tabDescription"]'
  );
  if (!descriptionTab) return;
  const descriptionLink = descriptionTab.querySelector("a.shp-tab-link");
  if (!descriptionLink) return;
  descriptionLink.textContent =
    window.language === "cs" ? "Detailní popis" : "Detailný popis";
};

const sizeTable = () => {
  const sizeTable = document.querySelector(".basic-description table");
  if (!sizeTable) return;
  sizeTable.classList.add("size-table");
  sizeTable.setAttribute("id", "sizeTable");
  const sizeTableHeading = createElement(
    "h5",
    ["size-table-heading"],
    window.language === "cs" ? "Tabulka velikostí" : "Tabuľka veľkostí"
  );

  sizeTable.prepend(sizeTableHeading);

  const variantsList = document.querySelector(".variant-list");
  if (!variantsList) return;
  const variantListHeading = variantsList.querySelector("th");
  if (!variantListHeading) return;

  const sizeTableLink = document.createElement("a");
  sizeTableLink.classList.add("size-table-link");
  sizeTableLink.href = "#";
  sizeTableLink.textContent =
    window.language === "cs" ? "Tabulka velikostí" : "Tabuľka veľkostí";
  if (
    variantListHeading.textContent.trim() === "Velikost:" ||
    variantListHeading.textContent.trim() === "Velikost"
  ) {
    variantListHeading.appendChild(sizeTableLink);
    variantsList.classList.add("size-table-variant-list");
    $(".size-table-link").on("click", function (e) {
      e.preventDefault();

      const sizeTable = document.querySelector(".size-table");
      if (!sizeTable) return;

      const clonedTable = sizeTable.cloneNode(true);

      const wrapperDiv = document.createElement("div");
      wrapperDiv.classList.add("colorbox-size-table");
      wrapperDiv.appendChild(clonedTable);

      $.colorbox({
        html: wrapperDiv.outerHTML,
        maxWidth: "850px",
        width: "100%",
      });
    });
  }
};
const manipulateProductAlternatives = () => {
  const productAlternatives = document.querySelector("#productsAlternative");
  if (!productAlternatives) return;
  productAlternatives.classList.remove("tab-pane", "fade");
  productAlternatives.classList.add("active", "in");
  productAlternatives
    .querySelectorAll(".alternative-heading")
    .forEach((title) => title.remove());
  const alternativeHeading = document.createElement("h2");
  alternativeHeading.classList.add("alternative-heading");
  alternativeHeading.textContent =
    window.language === "cs" ? "Podobné výrobky" : "Podobné produkty";
  productAlternatives.prepend(alternativeHeading);
};

changeTextDescription();

const bannerInProduct = () => {
  const productBanner = document.querySelector(".product-banner-src");
  if (!productBanner) return;

  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!pInfoWrapper) return;

  const bannerSrc = productBanner.querySelector("td").textContent.trim();

  const productBannerElm = document.createElement("div");
  productBannerElm.classList.add("product-banner-elm");
  productBannerElm.innerHTML = "<img src=" + bannerSrc + ">";
  console.log(productBannerElm);
  pInfoWrapper.appendChild(productBannerElm);
};
const changeThumbnailsInDetails = () => {
  const productThumbnails = document.querySelectorAll(
    ".p-thumbnails-inner img"
  );

  productThumbnails.forEach((thumbnail) => {
    const imageSrc = thumbnail.getAttribute("src").replace("related", "big");
    thumbnail.setAttribute("src", imageSrc);
  });
};
export {
  createShpTabLink,
  removeTabsSwitcher,
  handleProductTop,
  createAddToCartWrapper,
  moveTabsOnDetail,
  handleFavoritesIcon,
  handleFlagsOnDetail,
  changeTextOfLinkToDescription,
  handleBrandOnDetail,
  handleVariantsTable,
  changeThumbnailsInDetails,
  //variantsHandler,
  productDetailSocialsBtnMove,
  flagsInDetail,
  wrapPrices,
  sizeTable,
  manipulateProductAlternatives,
  couponInDetail,
  manipulateProductsRelated,
  bannerInProduct,
};
